import doc from '@/assets/images/list-doc-icon.webp';
import ofd from '@/assets/images/list-ofd-icon.webp';
import pdf from '@/assets/images/list-pdf-icon.webp';
import ppt from '@/assets/images/list-ppt-icon.webp';
import tif from '@/assets/images/list-tif-icon.webp';
import txt from '@/assets/images/list-txt-icon.webp';
import wps from '@/assets/images/list-wps-icon.webp';
import { getSuffix } from '@/utils';
import type { RcFile } from 'antd/lib/upload';

export const isImage = (type: string) =>
  type.match(/^image\/[a-zA-Z]+$/) !== null;

export const getBase64 = (file: RcFile) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  return reader;
};

const map = {
  pdf,
  doc,
  docx: doc,
  tif,
  tiff: tif,
  wps,
  txt,
  ppt,
  ofd,
} as Record<string, string>;

export const getResolvedSrc = (filename: string) => {
  const suffix = getSuffix(filename);
  if (suffix) {
    return map[suffix] || doc;
  }
  return doc;
};
